import VideoDescriptionField from './VideoDescriptionField.component';

export default VideoDescriptionField;